import { useState, useEffect } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { toast, Bounce } from "react-toastify";
import "./esperienzeLavorative.css";
import CustomSelect from "../CustomSelect";

const AddEsperienzaLavorativa = () => {
  const [formData, setFormData] = useState({
    ruolo: "",
    mansioneId: "",
    dal: "",
    al: "",
    nomeAzienda: "",
    descrizioneRuolo: "",
    trainerCodiceFiscale: "",
  });
  const [loading, setLoading] = useState(false);
  const [mansioni, setMansioni] = useState([]);
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole");
  const [errors, setErrors] = useState({});
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    if (userRole !== "TRAINER") {
      alert("Accedi come docente per aggiungere un'esperienza lavorativa!");
      navigate("/login");
      localStorage.clear();
    } else {
      fetchMansioni();
      setIsAuthorized(true);
    }
  }, [navigate, userRole]);

  const validate = (data) => {
    const newErrors = {};

    if (!data.ruolo) newErrors.ruolo = "Il campo Ruolo non può essere vuoto!";

    if (!data.mansioneId)
      newErrors.mansioneId = "Il campo Mansione non può essere vuoto!";

    if (!data.dal) newErrors.dal = "Il campo Data Inizio non può essere vuoto!";

    if (!data.nomeAzienda.trim())
      newErrors.nomeAzienda = "Il campo Nome Azienda non può essere vuoto!";

    if (!data.descrizioneRuolo.trim())
      newErrors.descrizioneRuolo =
        "Il campo Descrizione Ruolo non può essere vuoto!";

    if (userRole === "ADMIN" && !data.trainerCodiceFiscale.trim()) {
      newErrors.trainerCodiceFiscale = "Seleziona un docente!";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchMansioni = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/mansioni`);
      if (response.status === 200) {
        setMansioni(response.data);
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error("Errore durante il recupero di mansioni:", error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "mansioneId" ? Number(value) : value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSubmit = async () => {
    if (!validate(formData)) {
      return;
    }

    const payload = { ...formData };
    if (userRole !== "ADMIN") {
      delete payload.trainerCodiceFiscale;
    }

    setLoading(true);
    try {
      await api.post("/esperienze-lavorative", payload);
      toast.success("Esperienza lavorativa creata con successo!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      navigate("/esperienze-lavorative");
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthorized) return null;

  return (
    <div className="elav-modern-bg">
      {loading && (
        <div className="elav-modern-overlay">
          <div className="elav-modern-spinner"></div>
        </div>
      )}
      <div className="elav-modern-card add-esperienza">
        <div className="elav-modern-header">
          <button
            onClick={() => navigate("/esperienze-lavorative")}
            className="elav-modern-back"
            title="Torna indietro"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <h2>
            <i className="fa-solid fa-briefcase"></i>
            Aggiungi Esperienza Lavorativa
          </h2>
        </div>
        <form
          className="elav-modern-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="elav-modern-fields">
            <div className="elav-modern-field">
              <label className="elav-modern-label">
                <i className="fa-solid fa-user-tie"></i>
                Ruolo
              </label>
              <CustomSelect
                options={[
                  { value: "Titolare", label: "Titolare" },
                  { value: "Dipendente", label: "Dipendente" },
                  { value: "Consulente", label: "Consulente" },
                  { value: "Docente", label: "Docente" },
                ]}
                value={
                  formData.ruolo
                    ? {
                        value: formData.ruolo,
                        label: formData.ruolo,
                      }
                    : null
                }
                onChange={(selected) =>
                  handleChange({
                    target: {
                      name: "ruolo",
                      value: selected ? selected.value : "",
                    },
                  })
                }
                placeholder="Ruolo"
              />
              {errors.ruolo && (
                <span className="elav-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.ruolo}
                </span>
              )}
            </div>
            <div className="elav-modern-field">
              <label className="elav-modern-label">
                <i className="fa-solid fa-tasks"></i>
                Mansione
              </label>
              <CustomSelect
                options={mansioni.map((m) => ({
                  value: m.idMansione,
                  label: m.nomeMansione,
                }))}
                value={
                  formData.mansioneId
                    ? {
                        value: formData.mansioneId,
                        label:
                          mansioni.find(
                            (m) => m.idMansione === formData.mansioneId
                          )?.nomeMansione || "",
                      }
                    : null
                }
                onChange={(selected) =>
                  handleChange({
                    target: {
                      name: "mansioneId",
                      value: selected ? selected.value : "",
                    },
                  })
                }
                placeholder="Seleziona una mansione"
              />
              {errors.mansioneId && (
                <span className="elav-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.mansioneId}
                </span>
              )}
            </div>
            <div className="elav-modern-field">
              <label className="elav-modern-label">
                <i className="fa-solid fa-calendar-plus"></i>
                Data Inizio
              </label>
              <input
                type="date"
                name="dal"
                id="dal"
                value={formData.dal}
                onChange={handleChange}
                className={errors.dal ? "error" : ""}
              />
              {errors.dal && (
                <span className="elav-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.dal}
                </span>
              )}
            </div>
            <div className="elav-modern-field">
              <label className="elav-modern-label">
                <i className="fa-solid fa-calendar-minus"></i>
                Data Fine
              </label>
              <input
                type="date"
                name="al"
                id="al"
                value={formData.al}
                onChange={handleChange}
                className={errors.al ? "error" : ""}
              />
              {errors.al && (
                <span className="elav-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.al}
                </span>
              )}
            </div>
            <div className="elav-modern-field">
              <label className="elav-modern-label">
                <i className="fa-solid fa-building"></i>
                Nome Azienda
              </label>
              <input
                type="text"
                name="nomeAzienda"
                id="nomeAzienda"
                value={formData.nomeAzienda}
                onChange={handleChange}
                placeholder="Nome Azienda"
                className={errors.nomeAzienda ? "error" : ""}
              />
              {errors.nomeAzienda && (
                <span className="elav-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.nomeAzienda}
                </span>
              )}
            </div>
            <div className="elav-modern-field">
              <label className="elav-modern-label">
                <i className="fa-solid fa-align-left"></i>
                Descrizione del Ruolo
              </label>
              <textarea
                name="descrizioneRuolo"
                id="descrizioneRuolo"
                value={formData.descrizioneRuolo}
                onChange={handleChange}
                placeholder="Descrizione Ruolo"
                rows={3}
                className={errors.descrizioneRuolo ? "error" : ""}
              ></textarea>
              {errors.descrizioneRuolo && (
                <span className="elav-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.descrizioneRuolo}
                </span>
              )}
            </div>
            {userRole === "ADMIN" && (
              <div className="elav-modern-field">
                <label className="elav-modern-label">
                  <i className="fa-solid fa-id-card"></i>
                  Codice Fiscale del docente
                </label>
                <input
                  type="text"
                  name="trainerCodiceFiscale"
                  id="trainerCodiceFiscale"
                  value={formData.trainerCodiceFiscale}
                  onChange={handleChange}
                  placeholder="Codice Fiscale docente"
                  className={errors.trainerCodiceFiscale ? "error" : ""}
                />
                {errors.trainerCodiceFiscale && (
                  <span className="elav-modern-error">
                    <i className="fa-solid fa-exclamation-triangle"></i>
                    {errors.trainerCodiceFiscale}
                  </span>
                )}
              </div>
            )}
          </div>
          <div className="elav-modern-actions">
            <button
              type="button"
              className="elav-modern-cancel"
              onClick={() => navigate("/esperienze-lavorative")}
            >
              <i className="fa-solid fa-times"></i>
              Annulla
            </button>
            <button type="submit" className="elav-modern-save">
              <i className="fa-solid fa-plus"></i>
              Aggiungi
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEsperienzaLavorativa;
